/**
 * Pure formatting helpers. Kept separate from the `Th`/`Td` components so that
 * neither file mixes component and non-component exports (react-refresh).
 */
export function formatUSD(n: number): string {
  return `$${n.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 4 })}`;
}

export function formatDuration(ms: number | null): string {
  if (ms == null) return "—";
  if (ms < 1000) return `${ms} ms`;
  return `${(ms / 1000).toFixed(1)}s`;
}

export function formatNumber(n: number): string {
  return n.toLocaleString();
}

export function formatDateTime(iso: string): string {
  return new Date(iso).toLocaleString();
}
